import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, FormInput, Button, Alert } from "../../components/ui";
import { patchUser, getUser } from "../../api";
import { handleApiError } from "../../utils/apiErrorHandler";
import NotificationService from "components/alerts/index";

class UserAccountDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    let user;
    if (localStorage.getItem("user") !== null) {
      user = JSON.parse(localStorage.getItem("user"));
      this.setState({
        id: user.id,
        name: user.name,
        email: user.email,
        ownAffiliateKey: user.ownAffiliateKey,
        bio: user.bio,
      });
    }
  };

  patchUser = async () => {
    const data = {
      name: this.state.name,
      email: this.state.email,
    };
    let res = await patchUser(this.state.id, data);
    if (res && res.status === 200) {
      NotificationService.success("Account updated!");
      let userRes = await getUser(this.state.id);
      if (userRes.status === 200) {
        localStorage.setItem("user", JSON.stringify(userRes.data));
        let user = JSON.parse(localStorage.getItem("user"));
        this.setState({
          id: user.id,
          name: user.name,
          email: user.email,
          ownAffiliateKey: user.ownAffiliateKey,
          bio: user.bio,
        });
      }
    } else {
      const errorResponse = handleApiError(res, "Failed to update account");
      NotificationService.error(errorResponse.message);
    }
  };

  render() {
    return (
      <Card small className="mb-4 p-4">
        <Row>
          <Col>
            <Row form>
              {/* Last Name */}
              <Col md="6" lg="4" className="form-group">
                <label htmlFor="feLastName">Display Name</label>
                <FormInput
                  id="feLastName"
                  placeholder="Last Name"
                  value={this.state.name}
                  onChange={(text) =>
                    this.setState({ name: text.target.value })
                  }
                />
              </Col>
              {/* Email */}
              <Col md="6" lg="4" className="form-group">
                <label htmlFor="feEmail">Email address</label>
                <FormInput
                  type="email"
                  id="feEmail"
                  placeholder="Email Address"
                  value={this.state.email}
                  onChange={(text) =>
                    this.setState({ email: text.target.value })
                  }
                  autoComplete="email"
                />
              </Col>
            </Row>
            <Row form>
              {/* Username */}
              <Col md="6" lg="4" className="form-group">
                <label htmlFor="feUsername">Affiliate ID</label>
                <FormInput
                  id="feUsername"
                  placeholder="Username"
                  value={this.state.ownAffiliateKey}
                  disabled
                  onChange={() => {}}
                />
              </Col>
            </Row>
            <Row form>
              <Col md="12" lg="12 text-right buttons">
                <Button theme="accent" className="cancel">
                  Cancel
                </Button>
                <Button
                  theme="accent"
                  className="btn-gradient"
                  onClick={this.patchUser}
                >
                  Save changes
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    );
  }
}

UserAccountDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
};

UserAccountDetails.defaultProps = {};

export default UserAccountDetails;
